import { graphql } from "../../../shared/schema/gql";

export const GET_PATIENT_TASK_REGULARS_QUERY = graphql(`
  query GetPatientTaskRegularsV2(
    $limit: Int!
    $offset: Int!
    $order: [PatientTaskRegular__Order]
    $scheduledFrom: LocalDate
    $scheduledTo: LocalDate
    $statuses: [String!]
    $taskTemplateIds: [PatientTaskTemplateId!]
    $caregiverIds: [CaregiverId!]
    $patientIds: [PatientId!]
    $contractTypeIds: [ContractTypeId!]
    $officeIds: [OfficeId!]
  ) {
    patientTaskRegulars(
      limit: $limit
      offset: $offset
      order: $order
      scheduledFrom: $scheduledFrom
      scheduledTo: $scheduledTo
      statuses: $statuses
      taskTemplateIds: $taskTemplateIds
      caregiverIds: $caregiverIds
      patientIds: $patientIds
      contractTypeIds: $contractTypeIds
      officeIds: $officeIds
    ) {
      totalCount
      nodes {
        id
        patientId
        caregiverId
        taskName
        taskTemplateId
        patientContractId
        officeId
        createdAt
        createdBy
        scheduledDate
        status
        clockInTime
        clockOutTime
        notes
        duplicateOfDate
        patient {
          id
          firstName
          middleName
          lastName
        }
        caregiver {
          id
          firstName
          middleName
          lastName
        }
        contract {
          id
          contractType {
            id
            name
          }
        }
        office {
          id
          name
        }
        createdByMember {
          id
          firstName
          lastName
        }
        documents(limit: 100) {
          nodes {
            documentTypeId
            title
            fileUrl
            submitted
            approved
            approvedByName
            isScanned
            sentToPhysician
            isOpenForResubmission
            documentScheduleId
            reopenHistory(limit: 100) {
              nodes {
                reason
                reopenedAt
                reopenedByName
              }
            }
          }
        }
      }
    }
  }
`);

export const GET_PATIENT_TASK_FUTURES_QUERY = graphql(`
  query GetPatientTaskFuturesV2(
    $limit: Int!
    $offset: Int!
    $order: [PatientTaskFuture__Order]
    $scheduledFrom: LocalDate
    $scheduledTo: LocalDate
    $taskTemplateIds: [PatientTaskTemplateId!]
    $caregiverIds: [CaregiverId!]
    $patientIds: [PatientId!]
    $contractTypeIds: [ContractTypeId!]
  ) {
    patientTaskFutures(
      limit: $limit
      offset: $offset
      order: $order
      scheduledFrom: $scheduledFrom
      scheduledTo: $scheduledTo
      taskTemplateIds: $taskTemplateIds
      caregiverIds: $caregiverIds
      patientIds: $patientIds
      contractTypeIds: $contractTypeIds
    ) {
      totalCount
      nodes {
        seriesIndex
        patientId
        caregiverId
        taskName
        taskTemplateId
        patientContractId
        createdAt
        scheduledDate
        patient {
          id
          firstName
          middleName
          lastName
        }
        caregiver {
          id
          firstName
          middleName
          lastName
        }
        contract {
          id
          contractType {
            id
            name
          }
        }
      }
    }
  }
`);

// One task, for the documents drawer. Looked up by id rather than taken from the list so a link
// to a task opens it whatever page or filters the list is on.
export const GET_PATIENT_TASK_REGULAR_QUERY = graphql(`
  query GetPatientTaskRegularV2($id: PatientTaskInstanceId!) {
    patientTaskRegulars(id: { eq: $id }, limit: 1, offset: 0) {
      nodes {
        id
        patientId
        taskName
        scheduledDate
        status
        patient {
          id
          firstName
          middleName
          lastName
        }
        caregiver {
          id
          firstName
          middleName
          lastName
        }
        contract {
          id
          contractType {
            id
            name
          }
        }
        documents(limit: 100) {
          nodes {
            documentTypeId
            title
            fileUrl
            submitted
            approved
            approvedByName
            isScanned
            sentToPhysician
            isOpenForResubmission
            documentScheduleId
            reopenHistory(limit: 100) {
              nodes {
                reason
                reopenedAt
                reopenedByName
              }
            }
          }
        }
      }
    }
  }
`);
